// packages/web/src/components/auth/SlideDownLogin.tsx
// FAANG-GRADE: Login modal that slides down from header
// Uses shared LoginFormInner for identical login logic

import { Close } from '@mui/icons-material';
import { Box, IconButton, Paper, Slide, Typography } from '@mui/material';
import React, { useState } from 'react';

import LoginFormInner from './LoginFormInner';

interface SlideDownLoginProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  onSwitchToRegister?: () => void;
  catalogSlug?: string;
}

export function SlideDownLogin({
  open,
  onClose,
  onSuccess,
  onSwitchToRegister,
  catalogSlug,
}: SlideDownLoginProps) {
  const [loading, setLoading] = useState(false);

  const resetForm = () => {
    setLoading(false);
  };

  React.useEffect(() => {
    if (!open) {
      resetForm();
    }
  }, [open]);

  return (
    <Slide direction="down" in={open} mountOnEnter unmountOnExit>
      <Paper
        elevation={4}
        sx={{
          position: 'fixed',
          top: 64, // Below header
          left: 0,
          right: 0,
          zIndex: 1300,
          maxHeight: 'calc(100vh - 64px)',
          overflow: 'auto',
        }}
      >
        <Box sx={{ p: 3 }}>
          {/* Header with close button */}
          <Box
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}
          >
            <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold' }}>
              {catalogSlug ? `Login to ${catalogSlug}` : 'Login to Aithon'}
            </Typography>
            <IconButton onClick={onClose} disabled={loading}>
              <Close />
            </IconButton>
          </Box>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Welcome back! Please sign in to continue.
          </Typography>

          <Typography
            variant="body2"
            color="primary"
            sx={{ mb: 3, cursor: 'pointer' }}
            onClick={onSwitchToRegister}
          >
            Don't have an account? Register now →
          </Typography>

          {/* Use shared LoginFormInner for identical login logic */}
          <LoginFormInner
            catalogSlug={catalogSlug}
            isCatalogLogin={!!catalogSlug}
            showTitle={false}
            showLinks={false}
            onSuccess={onSuccess}
            loading={loading}
            isLoadingProp={loading}
          />
        </Box>
      </Paper>
    </Slide>
  );
}

export default SlideDownLogin;
